// export default function Footer() {
//     return (
//         <div className="-mt-20">
//             {/* 🌊 Wavy Top Border */}
//             <div className="relative -mb-1">
//                 <svg
//                     className="top-0 left-0 w-full rotate-180"
//                     viewBox="0 0 1440 150"
//                     xmlns="http://www.w3.org/2000/svg"
//                     preserveAspectRatio="none"
//                 >
//                     <path
//                         fill="black"  // <-- this is Tailwind's gray-800, change as needed
//                         d="M0,96L48,101.3C96,107,192,117,288,122.7C384,128,480,128,576,117.3C672,107,768,85,864,85.3C960,85,1056,107,1152,112C1248,117,1344,107,1392,101.3L1440,96L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
//                     />
//                 </svg>
//             </div>

//             {/* 🦶 Footer Container */}
//             <footer className="bg-black text-white pt-24 pb-10 relative z-10">
//                 <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
//                     <div>
//                         <h2 className="text-xl font-semibold mb-4">About Us</h2>
//                         <p className="text-sm text-gray-300">
//                             We build and deliver high-quality developments with a focus on sustainability and innovation.
//                         </p>
//                     </div>
//                     <div>
//                         <h2 className="text-xl font-semibold mb-4">Services</h2>
//                         <ul className="text-sm text-gray-300 space-y-2">
//                             <li>Residential</li>
//                             <li>Commercial</li>
//                             <li>Investment</li>
//                             <li>Consulting</li>
//                         </ul>
//                     </div>
//                     <div>
//                         <h2 className="text-xl font-semibold mb-4">Resources</h2>
//                         <ul className="text-sm text-gray-300 space-y-2">
//                             <li>Blog</li>
//                             <li>Case Studies</li>
//                             <li>FAQs</li>
//                         </ul>
//                     </div>
//                     <div>
//                         <h2 className="text-xl font-semibold mb-4">Contact</h2>
//                         <p className="text-sm text-gray-300">
//                             Email: contact@example.com <br />
//                             Phone: +123 456 7890
//                         </p>
//                     </div>
//                 </div>

//                 <div className="text-center text-sm text-gray-400 mt-10">
//                     © {new Date().getFullYear()} Your Company. All rights reserved.
//                 </div>
//             </footer>
//         </div>
//     );
// }



import { FaFacebookF } from 'react-icons/fa';
import { FaInstagram, FaXTwitter, FaYoutube } from 'react-icons/fa6';
import { MdEmail, MdPhone } from 'react-icons/md';

export default function Footer() {
    return (
        <div className="-mt-20">
            {/* 🌊 Curvy Top Border */}
            <div className="relative -mb-1">
                <svg
                    className="top-0 left-0 w-full rotate-180"
                    viewBox="0 0 1440 150"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                >
                    <path
                        fill="black"
                        d="M0,96L48,101.3C96,107,192,117,288,122.7C384,128,480,128,576,117.3C672,107,768,85,864,85.3C960,85,1056,107,1152,112C1248,117,1344,107,1392,101.3L1440,96L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
                    />
                </svg>
            </div>

            {/* 🦶 Footer Main Content */}
            <footer className="bg-black text-white pb-10 relative z-10">
                <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12">
                    {/* Left Section */}
                    <div>
                        <h2 className="text-2xl font-bold mb-2">R.A.B.®</h2>
                        <p className="text-sm text-gray-300 max-w-md mb-6">
                            RAB Company is a multi-vertical enterprise specializing in restaurant
                            services, property development, travel, and logistics. Driven by vision,
                            backed by legacy.
                        </p>
                        <div className="flex items-center text-sm text-gray-300 mb-2 gap-2">
                            <MdEmail className="text-lg" />
                            <a href='mailto:info@albidayahgroups.com'>info@albidayahgroups.com</a>
                        </div>
                        <div className="flex items-center text-sm text-gray-300 mb-4 gap-2">
                            <MdPhone className="text-lg" />
                            <a href='tel:+603-61285157'>+6 03-61285157</a>
                        </div>
                        <div className="flex space-x-4 mt-4 text-gray-300">
                            <a href="https://www.facebook.com/AlBidayahGroups/" target="_blank" rel="noopener noreferrer">
                                <FaFacebookF className="text-white text-2xl hover:text-blue-500 transition" />
                            </a>
                            <a href="https://www.instagram.com/al.bidayah.groups/" target="_blank" rel="noopener noreferrer">
                                <FaInstagram className="text-white text-2xl hover:text-pink-300 transition" />
                            </a>
                            <a href="https://x.com/AL_Bidayah_" target="_blank" rel="noopener noreferrer">
                                <FaXTwitter className="text-white text-2xl transition" />
                            </a>
                            <a href="https://www.youtube.com/@AL-Bidayah-Groups" target="_blank" rel="noopener noreferrer">
                                <FaYoutube className="text-white text-2xl hover:text-red-400 transition" />
                            </a>
                        </div>
                    </div>

                    {/* Right Section */}
                    <div className="grid grid-cols-2 gap-8">
                        {/* First Half */}
                        <div>
                            <h3 className="text-xl font-semibold mb-4">Navigation</h3>
                            <div className="h-px w-10 bg-gray-500 mb-4" />
                            <ul className="space-y-2 text-sm text-gray-300">
                                <li><a href="/" className="hover:text-white">Home</a></li>
                                <li><a href="/gallery" className="hover:text-white">Gallery</a></li>
                                <li><a href="/branches" className="hover:text-white">Branches</a></li>
                            </ul>
                        </div>

                        {/* Second Half */}
                        <div>
                            <h3 className="text-xl font-semibold mb-4">Company</h3>
                            <div className="h-px w-10 bg-gray-500 mb-4" />
                            <ul className="space-y-2 text-sm text-gray-300">
                                <li><a href="/about-us" className="hover:text-white">About Us</a></li>
                                <li><a href="/contact" className="hover:text-white">Contact Us</a></li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Footer Bottom */}
                <div className="text-center text-sm text-gray-500 mt-12 border-t border-gray-700 pt-6">
                    © {new Date().getFullYear()} Al Bidayah. All rights reserved.
                </div>
            </footer>
        </div>
    );
}
